export const download = (blob, filename) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;

  link.click();
  link.remove();

  URL.revokeObjectURL(link.href);
};
